import { useEffect } from 'react';
import RestUtilities from '../services/RestUtilities';
import { liveArtistsState, loadingState } from '../state/RecoilState';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { Artist } from '../@types/api';
import { artistStatus } from '../Constants';

export const useGetLiveArtists = () => {
  const setLoading = useSetRecoilState(loadingState);
  const [liveArtists, setLiveArtists] = useRecoilState(liveArtistsState);
  useEffect(() => {
    const getAllData = async () => {
      setLoading(true);
      const res = await RestUtilities.get('/api/artist/GetLiveArtists');
      if (res.ok) {
        setLiveArtists(
          res.content.filter((x: Artist) => x.status === artistStatus.LIVE)
        );
      }
      setLoading(false);
    };
    if (liveArtists.length === 0) {
      getAllData();
    }
  }, [liveArtists.length, setLiveArtists, setLoading]);
};
